
<mat-divider></mat-divider>

<div  style="padding: 10px; font-size: 14px; text-align: left">
  {{ 'activation.biss.info-one' | translate}}
  <ol>
    <li>
      {{ 'activation.biss.info-two' | translate}}
      <a style="font-size: 14px; font-weight: bold; text-decoration: underline" href="{{ downloadInfo.sacDownloadLink }}">
        {{ 'activation.biss.here' | translate}}    
      </a>
      <br>
      </li>
    <li>{{ 'activation.biss.info-three' | translate}}</li>
  </ol>
  <br>
  
</div>

<div *ngIf="bissCheckOngoing()" class="status-info">
  {{ 'activation.biss.check' | translate}}
</div>

<div *ngIf="bissNotFound()" style="padding: 10px; font-size: 13px; font-weight: bold;">
  {{ 'activation.biss.notFound-one' | translate}}
  {{ 'activation.biss.notFound-two' | translate}}
  <a style="font-size: 14px; font-weight: bold; text-decoration: underline" href="{{ downloadInfo.bissDownloadLink }}">
    {{ 'activation.biss.notFound-download' | translate}}    
  </a>
</div>

<div *ngIf="bissFoundOldVersion()" style="padding: 10px; font-size: 13px; font-weight: bold;">
  {{ 'activation.biss.foundOldVersion' | translate}}
  <a style="font-size: 13px; font-weight: bold; text-decoration: underline" href="{{ downloadInfo.bissDownloadLink }}">
    {{ 'activation.biss.notFound-download' | translate}}    
  </a>
</div>

<div *ngIf="bissFound()" class="status-info">
  {{ 'activation.biss.success' | translate}}
</div>
<div class="button-row">
  <div >
      <button [disabled]="!bissNotFound()" (click)="tryAgain()" class="navButton" >
          {{ 'activation.button.tryAgain' | translate }}
      </button>
  </div>
  <div >
      <button [disabled]="!bissFound()" (click)="stepComplete()" class="navButton">
          {{ 'activation.button.continue' | translate }}
      </button>
  </div>
</div>
